import React from 'react';
import practice from './images/sestava/hero.jpg';

export default function Hero() {
    return <>
        <section id="hero" className="home-hero">
            <div className="hero-copy">
                <p className="eyebrow"><span className="small-line" /> Cesta mého vnitřního Já</p>
                <h1>Probuďte<br />svou <em>energii.</em></h1>
                <p className="hero-description">Objevte autorskou sestavu Tomáše Číhala: Cesta mého vnitřního já za 4 elementy. Pohyb, dech a příběhy přírody v jedinečné praxi, kterou vás osobně provede její autor.</p>
                <div className="hero-actions">
                    <a href="#schedule" className="button button-primary">Přijít na první lekci <span aria-hidden="true">↗</span></a>
                    <a href="#elements" className="button button-secondary">Objevit sestavu</a>
                </div>
                <div className="hero-details"><span>Začněte vlastním tempem</span><span>Plzeň · Hala Krašovská</span></div>
            </div>
            <figure className="hero-portrait signature-hero">
                <img src={practice} alt="Tomáš Číhal u jezera při západu slunce. Harmonizační sestava Cesta mého vnitřního já za 4 elementy." fetchPriority="high" width="1254" height="1254" />
            </figure>
        </section>
        <div className="practice-strip">
            <div><p className="eyebrow">Probuďte svou vnitřní energii</p><p>Hala Krašovská, Plzeň <span className="strip-separator">/</span> Pondělí a středa · 18:00–19:30</p></div>
            <a href="#upcoming-events" className="text-link">Nadcházející akce <span aria-hidden="true">↗</span></a>
        </div>
    </>;
}
